import { PaymentData, PaymentInfo, SubscriptionStatus } from "../types";

export class SubscriptionData {
  statusData: SubscriptionStatus;
  paymentInfo: PaymentInfo;
  constructor(subscriptionStatus: SubscriptionStatus, paymentInfo: PaymentInfo) {
    this.statusData = subscriptionStatus;
    this.paymentInfo = paymentInfo;
  }

  isPaymentRequired(): boolean {
    return (
      !this.statusData.subscription.basic.hasSubscription &&
      !this.statusData.subscription.basic.hasTrial
    );
  }

  missingPaymentInfo(): boolean {
    return Object.keys(this.paymentInfo).length === 0
  }

  getDaysAmount(): number {
    return this.paymentInfo.trial!.days
  }

  getPaymentData(): PaymentData {
    return this.isPaymentRequired()
      ? this.paymentInfo.payment!
      : this.paymentInfo.trial!.paymentAfterTrial;
  }

  getClientSecret(): string {
    if (this.isPaymentRequired()) {
      return this.paymentInfo!.payment!.stripePaymentIntent.clientSecret;
    }

    return this.paymentInfo.trial!.stripeSetupIntent.clientSecret;
  }
}
